import { render } from "./ForceView.vue?vue&type=template&id=2d81a148"
import script from "./ForceView.vue?vue&type=script&lang=js"
export * from "./ForceView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__